const NavIcon = ({ type, compact = false, className = '' }) => {
  const iconClass = compact
    ? 'nav-icon flex h-5 w-5 shrink-0 rounded-md border border-text-muted/60'
    : 'nav-icon flex h-8 w-8 shrink-0 rounded-lg border border-text-muted/60'

  const mergedIconClass = [iconClass, className].filter(Boolean).join(' ')

  if (type === 'showreel') {
    return (
      <span
        className={`${mergedIconClass} items-center justify-center`}
        aria-hidden="true"
      >
        <span
          className={
            compact
              ? 'ml-px block h-0 w-0 border-y-[3px] border-l-[5px] border-y-transparent border-l-text-muted'
              : 'ml-0.5 block h-0 w-0 border-y-[5px] border-l-[8px] border-y-transparent border-l-text-muted'
          }
        />
      </span>
    )
  }

  if (type === 'grid') {
    return (
      <span
        className={`${mergedIconClass} grid grid-cols-2 ${compact ? 'gap-px p-px' : 'gap-1 p-0.5'}`}
        aria-hidden="true"
      >
        <span className="nav-icon-cell rounded-sm border border-text-muted/60" />
        <span className="nav-icon-cell rounded-sm border border-text-muted/60" />
        <span className="nav-icon-cell rounded-sm border border-text-muted/60" />
        <span className="nav-icon-cell rounded-sm border border-text-muted/60" />
      </span>
    )
  }

  if (type === 'about') {
    return (
      <img
        src={`${process.env.PUBLIC_URL}/images/darren-about.png`}
        alt=""
        className={`${mergedIconClass} object-cover`}
        aria-hidden="true"
      />
    )
  }

  if (type === 'contact') {
    return (
      <span
        className={`${mergedIconClass} items-center justify-center`}
        aria-hidden="true"
      >
        <span className={compact ? 'block h-px w-2.5 bg-text-muted' : 'block h-px w-4 bg-text-muted'} />
      </span>
    )
  }

  return (
    <span className={`${mergedIconClass} items-center justify-center`} aria-hidden="true">
      <span className={compact ? 'block h-px w-2.5 bg-text-muted' : 'block h-px w-4 bg-text-muted'} />
    </span>
  )
}

export default NavIcon
